module.exports = __webpack_public_path__ + "static/Madhu-1275a26793c1786834b017d82dff9976.png";